export default "__VITE_ASSET__CqR7Lnin__"